export const FORM_REDIRECT_URL_MAX_LENGTH = 2048;

const ALLOWED_REDIRECT_URL_PROTOCOLS = new Set(["http:", "https:"]);

export const isValidFormRedirectUrl = (value: string): boolean => {
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > FORM_REDIRECT_URL_MAX_LENGTH) {
    return false;
  }

  if (trimmed.startsWith("//")) {
    return false;
  }

  if (!/^https?:\/\/[^/]/i.test(trimmed)) {
    return false;
  }

  try {
    const parsed = new URL(trimmed);
    return ALLOWED_REDIRECT_URL_PROTOCOLS.has(parsed.protocol);
  } catch {
    return false;
  }
};

export const parseFormRedirectUrl = (value: string): string | undefined => {
  const trimmed = value.trim();
  if (!isValidFormRedirectUrl(trimmed)) {
    return undefined;
  }

  return trimmed;
};
